import React from 'react';
import { useHistory } from 'react-router-dom';
import Icon from 'assets/Icon';
import Card from '../Card';
import styles from './style/lineCard.module.css';

interface LineCardProps {
  loading?: boolean,
  lineName?: string,
  lineRef?: string,
}

function LineCard({ loading, lineName, lineRef }:LineCardProps) {
  const history = useHistory();
  function handleClick() {
    if (loading) return;
    history.push({
      pathname: `batches/${lineRef}`,
      state: { lineName },
    });
  }
  return (
    <Card elevation="2-4">
      <div
        className={styles.lineCard}
        data-automation-id={`line-${lineRef}`}
        onClick={handleClick}
        onKeyDown={handleClick}
        role="button"
        tabIndex={0}
      >
        { loading ? (
          <>
            <span className={styles.lineCard__loading} />
            <div className={`${styles.lineCard__icon} ${styles.lineCard__icon_loading}`} />
          </>
        ) : (
          <>
            <h3 className="subtitle1">{ lineName }</h3>
            <div className={styles.lineCard__icon}>
              <Icon fill="white" icon="ArrowRight" size={16} />
            </div>
          </>
        )} 
      </div>
    </Card>
  );
}

LineCard.defaultProps = {
  loading: false,
  lineName: '',
  lineRef: '',
}

export default LineCard;
